import { wplToken } from '@atlassiansox/wpl-token';
import { getColor, getMediaDown } from '@atlassiansox/wpl-utils';
import { css } from '@emotion/react';

export const containerStyles = css`
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;
  display: flex;

  ${getMediaDown('md')} {
    display: none;
  }
`;

export const mobileContainerStyles = css`
  display: none;
  background: white;
  width: 100%;
  box-sizing: border-box;
  justify-content: space-between;
  z-index: 1000;
  padding: 16px 0;
  margin: 0 0 32px 0;
  border-bottom: 1px solid ${getColor('n50')};
  position: sticky;
  top: 0;
  left: 0;
  right: 0;

  ${getMediaDown('md')} {
    display: flex;
  }
`;

export const restartButtonStyles = css`
  color: ${getColor('b300')};
  font-family: var(--bxp-charlie-text-font-family);
  font-size: 1rem;
  cursor: pointer;
  background: none;
  border: none;
  margin-right: ${wplToken('space.300')};
  &:hover,
  &:focus {
    color: ${getColor('b500')};
  }

  ${getMediaDown('md')} {
    margin: 0;
    padding-left: 0;
  }
`;

export const mobileSpacerStyles = css`
  display: none;

  ${getMediaDown('md')} {
    display: block;
  }
`;
